// src/components/studio/StudioFooter.tsx
import { ChevronRight } from "lucide-react";
import { StepId, StepValidation } from "../../types/studio.types";

interface StudioFooterProps {
  activeStep: StepId;
  validation: StepValidation;
  showSavedCardFooter: boolean;
  showEditingFooter: boolean;
  isSaving: boolean;
  hasUnsavedChanges: boolean;
  onNext: () => void;
  onPreview: () => void;
  onPayment: () => void;
}

export default function StudioFooter({
  activeStep,
  validation,
  showSavedCardFooter,
  showEditingFooter,
  isSaving,
  hasUnsavedChanges,
  onNext,
  onPreview,
  onPayment,
}: StudioFooterProps) {
  const isValid =
    validation[`isStep${activeStep}Valid` as keyof typeof validation];

  if (showSavedCardFooter) {
    return (
      <footer className="mt-6">
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onPreview}
            className="flex-1 bg-white/10 border border-white/20 py-4 rounded-2xl font-black uppercase text-xs tracking-[0.2em] transition-all hover:bg-white/20"
          >
            Preview
          </button>
          <button
            type="button"
            onClick={onPayment}
            className="flex-1 bg-primary py-4 rounded-2xl font-black uppercase text-xs tracking-[0.2em] shadow-xl shadow-primary/20 active:scale-95 transition-all"
          >
            Share Now
          </button>
        </div>
      </footer>
    );
  }

  if (showEditingFooter) {
    return (
      <footer className="mt-6">
        <button
          type="button"
          onClick={onNext}
          disabled={isSaving || (activeStep < 4 && !isValid)}
          className="w-full bg-primary py-4 rounded-2xl font-black uppercase text-xs tracking-[0.2em] flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSaving
            ? "Saving..."
            : activeStep === 3
              ? hasUnsavedChanges
                ? "Save Changes"
                : "Finalize Surprise"
              : "Continue"}
          {!isSaving && <ChevronRight size={16} />}
        </button>
      </footer>
    );
  }

  return null;
}
